import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  private url = 'http://51.75.62.77:8040/api/Images';
  constructor(private http: HttpClient) {}

  getImages() {
    return this.http.get(this.url, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      }),
    });
  }

  getImage(name: string) {
    return this.http.get(this.url + '/' + name, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      }),
    });
  }
}
